import '@google/model-viewer';
import './css/styles.css';
import { initHotspotManager } from './js/modules/hotspot-manager.js';
import { initImageUpload } from './js/modules/image-handler.js';
import { loadHotspots, saveHotspots } from './js/modules/api-service.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM content loaded');
    
    // Cleanup all hotspot-related localStorage data
    console.log('Cleaning up localStorage hotspot data...');
    Object.keys(localStorage).forEach(key => {
        if (key.startsWith('hotspots_')) {
            console.log(`Removing localStorage item: ${key}`);
            localStorage.removeItem(key);
        }
    });
    console.log('localStorage cleanup complete');
    
    // Utility function to display error messages
    window.displayErrorMessage = function(message) {
        const errorContainer = document.getElementById('error-container');
        if (errorContainer) {
            errorContainer.textContent = message;
            errorContainer.style.display = 'block';
            
            // Hide after 5 seconds
            setTimeout(() => {
                errorContainer.style.opacity = '0';
                setTimeout(() => {
                    errorContainer.style.display = 'none';
                    errorContainer.style.opacity = '1';
                }, 300);
            }, 5000);
        }
    };
    
    const modelViewer = document.querySelector('model-viewer');
    const loading = document.getElementById('loading');
    const loadingBarProgress = document.getElementById('loading-bar-progress');
    const exposureSlider = document.getElementById('exposure-slider');
    const exposureValue = document.getElementById('exposure-value');
    const annotationControl = document.getElementById('annotation-control');
    const hotspotPreview = document.getElementById('hotspot-preview');
    const hotspotEditPanel = document.getElementById('hotspot-edit-panel');
    const saveHotspotBtn = document.getElementById('save-hotspot');
    const cancelHotspotBtn = document.getElementById('cancel-hotspot');
    const deleteHotspotBtn = document.getElementById('delete-hotspot');
    const hotspotImage = document.getElementById('hotspot-image');
    const imagePreviewContainer = document.getElementById('image-preview-container');
    const imagePreview = document.getElementById('image-preview');
    const removeImageBtn = document.getElementById('remove-image');
    
    if (!modelViewer) {
        console.error('Model viewer not found');
        return;
    }
    
    console.log('Model viewer found');
    
    // Check if model-viewer is defined
    if (customElements.get('model-viewer')) {
        console.log('model-viewer is defined');
    } else {
        console.error('model-viewer is NOT defined');
    }
    
    // Initialize image upload handler
    const imageHandler = initImageUpload(hotspotImage, imagePreviewContainer, imagePreview, removeImageBtn);
    
    // Initialize hotspot manager
    const hotspotManager = initHotspotManager(modelViewer, hotspotPreview, hotspotEditPanel, imageHandler);
    
    // Function to load hotspots from localStorage
    async function loadHotspotsForModel() {
        // Extract model ID from the URL more robustly
        const modelUrl = modelViewer.src;
        const urlParts = modelUrl.split('/');
        const filename = urlParts[urlParts.length - 1];
        const modelId = filename.split('.')[0]; // Extracts "Sodrastation-v1" from "Sodrastation-v1.glb"
        
        console.log('Loading hotspots for model:', modelId, 'from URL:', modelUrl);
        
        const hotspotData = await loadHotspots(modelId);
        console.log('Loaded hotspots data for model ID:', modelId, 'count:', hotspotData.length);
        
        // Clear existing hotspots
        modelViewer.querySelectorAll('.hotspot').forEach(el => el.remove());
        document.querySelectorAll('.annotation').forEach(el => el.remove());
        
        // Create hotspots from data
        hotspotData.forEach(data => {
            // Create hotspot element
            const hotspot = document.createElement('button');
            hotspot.slot = data.slot;
            hotspot.id = `hotspot-id-${data.id || Math.random().toString(36).substring(2, 9)}`;
            hotspot.classList.add('hotspot');
            hotspot.style.width = '20px';
            hotspot.style.height = '20px';
            hotspot.style.borderRadius = '50%';
            hotspot.style.backgroundColor = data.color;
            hotspot.style.border = 'none';
            hotspot.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.25)';
            hotspot.style.cursor = 'pointer';
            
            // Store data attributes
            hotspot.dataset.position = data.position;
            hotspot.dataset.normal = data.normal;
            hotspot.dataset.name = data.name;
            hotspot.dataset.text = data.text;
            
            if (data.imageUrl && data.imageUrl !== '' && data.imageUrl !== 'null') {
                hotspot.dataset.imageUrl = data.imageUrl;
            }
            
            if (data.thumbnailUrl && data.thumbnailUrl !== '' && data.thumbnailUrl !== 'null') {
                hotspot.dataset.thumbnailUrl = data.thumbnailUrl || data.imageUrl;
            }
            
            // Create annotation element
            const annotation = document.createElement('div');
            annotation.classList.add('annotation');
            annotation.style.position = 'fixed';
            annotation.style.backgroundColor = 'white';
            annotation.style.opacity = '0.9';
            annotation.style.borderRadius = '6px';
            annotation.style.padding = '8px';
            annotation.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.25)';
            annotation.style.display = 'none';
            annotation.style.zIndex = '10000';
            annotation.style.pointerEvents = 'auto';
            
            // Set annotation content
            let content = `
                <h3 style="margin: 0 0 4px 0; font-size: 14px; font-weight: bold;">${data.name}</h3>
                <p style="margin: 0; font-size: 12px;">${data.text}</p>
            `;
            
            if (data.created_by) {
                content += `<p style="margin: 4px 0 0 0; font-size: 10px; color: #666;">Skapad av: ${data.created_by}</p>`;
            }
            
            annotation.innerHTML = content;
            
            // Add image if available
            if (data.imageUrl && data.imageUrl !== '' && data.imageUrl !== 'null') {
                console.log('Creating image element for hotspot:', data.name);
                console.log('Image URL:', data.imageUrl);

                let imageUrl = data.imageUrl;

                if (typeof imageUrl === 'string') {
                    imageUrl = imageUrl.replace(/ /g, '%20');
                    console.log('Encoded image URL:', imageUrl);
                }

                if (data.thumbnailUrl) {
                    console.log('Thumbnail URL:', data.thumbnailUrl);

                    if (typeof data.thumbnailUrl === 'string') {
                        imageUrl = data.thumbnailUrl.replace(/ /g, '%20');
                        console.log('Encoded thumbnail URL:', imageUrl);
                    }
                }

                if (typeof imageUrl === 'object') {
                    console.warn('imageUrl is an object, using empty string instead:', imageUrl);
                    imageUrl = '';
                }

                const img = document.createElement('img');
                img.crossOrigin = 'anonymous'; // Add crossOrigin attribute
                img.src = imageUrl;
                img.alt = data.name;
                img.className = 'hotspot-thumbnail';
                img.style.cursor = 'default';

                
// Add error handling for images
                img.onerror = function() {
                    console.error('Failed to load hotspot image:', imageUrl);
                    img.classList.add('error');
                    img.style.width = '100px';
                    img.style.height = '60px';
                    img.alt = 'Image failed to load';
                };

                annotation.appendChild(img);

                img.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // Open the image in a modal when clicked
                    const fullImageUrl = data.imageUrl || imageUrl;
                    if (fullImageUrl) {
                        import('./js/modules/image-handler.js').then(module => {
                            module.createImageModal(fullImageUrl);
                        });
                    }
                });
            }
            
            document.body.appendChild(annotation);
            
            // Show annotation on hover
            hotspot.addEventListener('mouseenter', () => {
                const rect = hotspot.getBoundingClientRect();
                annotation.style.display = 'block';
                annotation.style.left = `${rect.right + 10}px`;
                annotation.style.top = `${rect.top}px`;
                annotation.style.width = 'auto';
                annotation.style.maxWidth = '200px';
                
                // Adjust if it goes off screen
                const annotRect = annotation.getBoundingClientRect();
                if (annotRect.right > window.innerWidth) {
                    annotation.style.left = (rect.left - annotRect.width - 10) + 'px';
                }
                if (annotRect.bottom > window.innerHeight) {
                    annotation.style.top = (window.innerHeight - annotRect.height) + 'px';
                }
            });
            
            // Hide annotation on mouse leave
            hotspot.addEventListener('mouseleave', () => {
                annotation.style.display = 'none';
            });
            
            // Handle hotspot click
            hotspot.addEventListener('click', (e) => {
                e.stopPropagation();
                console.log('Hotspot clicked:', hotspot.id, hotspot.dataset.name);
                
                // Show edit panel at hotspot position
                const rect = hotspot.getBoundingClientRect();
                hotspotEditPanel.style.display = 'block';
                hotspotEditPanel.style.left = `${rect.left}px`;
                hotspotEditPanel.style.top = `${rect.top}px`;
                
                // Fill in form fields
                document.getElementById('hotspot-name').value = hotspot.dataset.name;
                document.getElementById('hotspot-text').value = hotspot.dataset.text;
                
                // Handle image preview
                if (hotspot.dataset.imageUrl && hotspot.dataset.imageUrl !== '' && hotspot.dataset.imageUrl !== 'null') {
                    imagePreview.src = hotspot.dataset.imageUrl.replace(/ /g, '%20');
                    
                    if (hotspot.dataset.thumbnailUrl) {
                        imageHandler.setCurrentImageUrl(hotspot.dataset.imageUrl, hotspot.dataset.thumbnailUrl);
                    } else {
                        imageHandler.setCurrentImageUrl(hotspot.dataset.imageUrl);
                    }
                    
                    imagePreviewContainer.classList.remove('hidden');
                } else {
                    imageHandler.resetImageUpload();
                }
                
                // Show delete button
                deleteHotspotBtn.style.display = 'inline-block';
                
                console.log('Setting current hotspot in click handler:', hotspot.id);
                
                // Set current hotspot with a small delay to ensure all event handlers are processed
                setTimeout(() => hotspotManager.setCurrentHotspot(hotspot), 0);
            });
            
            // Add hotspot to model viewer
            modelViewer.appendChild(hotspot);
        });
        
        // Update hotspot counter if there are existing hotspots
        if (hotspotData.length > 0) {
            const maxSlotNumber = Math.max(...hotspotData.map(data => {
                return parseInt(data.slot.split('-')[1] || '0', 10);
            }), -1) + 1;
            
            hotspotManager.setHotspotCounter(maxSlotNumber);
        }
    }
    
    // Exposure slider event
    exposureSlider.addEventListener('input', function() {
        const value = parseFloat(this.value);
        modelViewer.exposure = value;
        exposureValue.textContent = value.toFixed(1);
    });
    
    // Annotation control button event
    annotationControl.addEventListener('click', function() {
        if (hotspotManager.isPlacingHotspot()) {
            hotspotManager.cancelHotspotPlacement();
        } else {
            hotspotManager.startHotspotPlacement();
        }
    });
    
    // Remove image button event
    removeImageBtn.addEventListener('click', function() {
        console.log('Remove image button clicked directly');
        
        const currentHotspot = hotspotManager.getCurrentHotspot();
        console.log('Current hotspot when remove button clicked:', currentHotspot);
        
        if (currentHotspot && currentHotspot.tagName === 'BUTTON') {
            console.log('Removing image properties from hotspot');
            
            delete currentHotspot.dataset.imageUrl;
            delete currentHotspot.dataset.thumbnailUrl;
            
            imagePreview.src = '';
            imagePreviewContainer.classList.add('hidden');
            
        }
        
        imageHandler.setImageExplicitlyRemoved(true);
    });
    
    // Image removed event listener
    document.addEventListener('imageRemoved', function(event) {
        console.log('imageRemoved event received:', event.detail);
        console.log('Timestamp:', event.detail.timestamp);
        
        if (hotspotManager.getCurrentHotspot && hotspotManager.getCurrentHotspot()) {
            const currentHotspot = hotspotManager.getCurrentHotspot();
            console.log('Current hotspot in imageRemoved event:', currentHotspot);
            
            if (currentHotspot && currentHotspot.tagName === 'BUTTON') {
                console.log('Removing imageUrl and thumbnailUrl from currentHotspot dataset');
                
                delete currentHotspot.dataset.imageUrl;
                delete currentHotspot.dataset.thumbnailUrl;
                
                console.log('imageUrl and thumbnailUrl removed from currentHotspot dataset');
                
            }
        }
    });
    
    // Mouse move event for tracking cursor position
    document.addEventListener('mousemove', hotspotManager.trackMouseMovement);
    
    // Model click event for placing hotspots
    modelViewer.addEventListener('click', hotspotManager.handleModelClick);
    
    // Save hotspot button event
    saveHotspotBtn.addEventListener('click', function() {
        console.log('Save button clicked');
        hotspotManager.saveCurrentHotspot();
    });
    
    // Cancel hotspot edit button event
    cancelHotspotBtn.addEventListener('click', hotspotManager.cancelHotspotEdit);
    
    // Delete hotspot button event
    deleteHotspotBtn.addEventListener('click', async () => {
        console.log('Delete button clicked');
        await hotspotManager.deleteCurrentHotspot();
        setTimeout(loadHotspotsForModel, 500);
    });
    
    // Model loaded event
    modelViewer.addEventListener('load', function() {
        console.log('Model loaded successfully');
        loading.classList.add('hidden');
        setTimeout(loadHotspotsForModel, 500);
    });
    
    // Model error event
    modelViewer.addEventListener('error', function(error) {
        console.error('Error loading model:', error);
        console.error('Error detail:', error.detail);
        console.error('Error target:', error.target.id);
        
        // Create a detailed error report
        let errorReport = {
            timestamp: new Date().toISOString(),
            modelSrc: modelViewer.src,
            error: error,
            browser: navigator.userAgent,
            screenSize: `${window.innerWidth}x${window.innerHeight}`
        };
        console.error('Error report:', JSON.stringify(errorReport, (key, value) => {
            if (value instanceof Event) {
                return `[Event of type ${value.type}]`;
            }
            return value;
        }));
        
        try {
            // Try fetching the model directly to check if it's accessible
            fetch(modelViewer.src, { method: 'HEAD' })
                .then(response => {
                    console.log(`Model HEAD request status: ${response.status}`);
                    console.log(`Model HEAD response headers:`, Object.fromEntries([...response.headers]));
                })
                .catch(fetchError => {
                    console.error('Error fetching model directly:', fetchError);
                });
        } catch (e) {
            console.error('Error while trying to fetch model:', e);
        }
        
        loading.innerHTML = '<div style="color: #ef4444;">Error loading model. Please try again.</div>';
    });
    
    // Model loading progress event
    modelViewer.addEventListener('progress', function(event) {
        const progress = event.detail.totalProgress;
        console.log('Loading progress:', progress);
        
        // Update loading screen progress bar
        if (loadingBarProgress) {
            loadingBarProgress.style.width = (progress * 100) + '%';
        }
    });
    
    // Fallback timeout to hide loading screen if the model takes too long
    setTimeout(function() {
        console.log('Fallback timeout triggered');
        if (modelViewer.loaded) {
            console.log('Model actually loaded, just slow to report');
        } else {
            console.warn('Model still not loaded after timeout');
            
            // Force a reload of the model
            const currentSrc = modelViewer.src;
            modelViewer.src = '';
            
            setTimeout(() => {
                console.log('Attempting to reload model');
                modelViewer.src = currentSrc;
            }, 500);
        }
        loading.classList.add('hidden');
    }, 10000);
});